<!--begin header -->
<header class="header">
    <app-header [addlClass]="'home-header'"></app-header>

</header>
<!--end header -->

<!--begin home section -->
<section class="home-section" id="home" aria-label="Money Transfer Overseas">

    <!-- <div class="home-section-overlay"></div> -->

    <!--begin container -->
    <div class="container">

        <div class="row d-flex align-items-center mt-3">
            <div class="col-lg-6 col-md-12 mt-3">
                <h1 [attr.data-aos]="'fade-up'" data-aos-duration="500" style="font-weight: 700;">
                    The Smartest Way To Send Money Overseas
                </h1>
                <p class="hero-text" [attr.data-aos]="'fade-up'" data-aos-delay="50" data-aos-duration="500">
                    Low Fees, Competitive Exchange Rates and No Hidden Charges!
                </p>
                <div class="button-image-column">
                   <!-- Image that triggers the modal -->
                   <div class="image-container" *ngIf="country == 'sg'" (click)="openDialog()">
                    <img 
                        src="/assets/images/mmt_img.jpeg" 
                        class="launch-image"
                        alt="Make My Trip Launching Image" 
                    />
                    <div class="play-icon">
                        <img src="/assets/images/play_icon.png" alt="Play Icon">
                    </div>
                </div>
                   <a rel="noreferrer" (click)="redirectToRegistrationPage()" class="btn getStarted"
                   [attr.style]="isMobile ? 'padding-left:20px;padding-right:20px;' : 'padding-left:48px;padding-right:48px;'">
                   Get Started
               </a>

<!-- Dialog Overlay -->
<div class="overlay" *ngIf="isDialogOpen">
    <div class="dialog">
        <!-- Close button -->
        <span class="close-btn" (click)="closeDialog()">&times;</span>

        <!-- YouTube iframe -->
        <iframe class="responsive-iframe"
            src="https://www.youtube.com/embed/WbzRrI-Zg20?autoplay=1&playsinline=1&rel=0&modestbranding=1"
            allow="autoplay; fullscreen"
            frameborder="0"
            allowfullscreen>
        </iframe>
    </div>
</div>
               
                </div>
            </div>
            <div class="col-lg-5 col-md-12 offset-lg-1">
                <div class="excalc-form-warpper">
                    <h3 class="mb-3 text-bold">Fair Exchange Calculator</h3>
                    <div>
                        <app-ex-calc></app-ex-calc>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <!--end container -->

</section>
<!--end home section -->



<!-- award section started-->
<section *ngIf="country == 'sg' || country == 'hk' " style="margin-top: -80px; margin-right: 0;z-index: 1;
position: relative;">
    <div class="row" style="margin-right: 0;">
        <div class="col-lg-5 col-md-12"></div>
        <div class="col-lg-6 col-md-12 offset-lg-1">
            <div class="row" style="align-items: baseline;">
                <div class="col-md-4" style="text-align: center;padding-top: 15px;">
                    <a href="https://search.google.com/local/reviews?placeid=ChIJRXlLlg0Z2jERdtIfqV-fVTs"
                        target="_blank"><img class="lazyload" data-src="./assets/images/google_review.png"
                            alt="SingX Money Transfer Overseas - Google Review" style="width: 200px;"></a>
                </div>
                <div class="col-md-3" style="text-align: center;padding: 10px;"><img class="lazyload"
                        data-src="./assets/images/MAS_Award_Icon.webp"
                        alt="SingX Transfer Money Overseas - MAS Global Fintech Award 2017"
                        [attr.style]="isMobile ? 'width: 120px;':'width: 150px;'"></div>
                <div class="col-md-3" style="text-align: center;padding-top: 15px;"><img class="lazyload"
                        data-src="./assets/images/SBR_Hottest_award.webp"
                        alt="SingX International Fund Transfer - Hottest Startup in 2018 Award" style="width: 150px;">
                </div>
            </div>
        </div>
    </div>
</section>
<!-- award section end-->

<!-- au award section started-->
<section *ngIf="country == 'au' " style="margin-right: 0;z-index: 1;
position: relative; padding-top: 10px;">
    <div class="awards-list">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-lg-10 col-md-12 awards-list-section">
                <div class="row awards" style="align-items: baseline;">

                    <div class="col-md-3 g-review" style="text-align: center;">
                        <a href="https://search.google.com/local/reviews?placeid=ChIJRXlLlg0Z2jERdtIfqV-fVTs"
                            target="_blank"><img class="greview lazyload" data-src="./assets/images/google_review.png"
                                alt="SingX Money Transfer Overseas - Google Review"></a>
                    </div>
                    <div class="col-md-2" style="text-align: center;padding: 10px;">
                        <img class="hottestaward lazyload" data-src="./assets/images/MAS_Award_Icon.webp"
                            alt="SingX Transfer Money Overseas - MAS Global Fintech Award 2017">
                    </div>
                    <div class="col-md-2" style="text-align: center;padding-top: 15px;">
                        <img class="hottestaward lazyload" data-src="./assets/images/SBR_Hottest_award.webp"
                            alt="SingX International Fund Transfer - Hottest Startup in 2018 Award">
                    </div>
                    <div class="col-8 col-sm-3 licence" style="text-align: center;padding: 15px;">
                        <div class="row">
                            <div class="col-lg-12 col-md-12 offset-lg-1">
                                <div class="row">
                                    <div class="col-md-3">
                                        <img src="./assets/images/license-icon.webp" class="licence-img" alt="SingX - Licensed by Australia
                                        Securities and Investments Commission (ASIC)">
                                    </div>
                                    <div class="col license">
                                        Licensed by Australia<br>Securities and Investments Commission (ASIC)
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1"></div>
        </div>
    </div>
</section>
<!-- award section end-->

<!--begin Services-We-offer -->
<section class="section-bg-2 pb-3" id="about" *ngIf="country == 'sg'">
    <h2 class="coverage-heading text-center services">Global Payments Services We Offer</h2>
    <!--begin services-wrapper -->
    <div class="services-wrapper">
        <!--begin container -->
        <div class="container">
            <!--begin row -->
            <div class="row align-items-center">
                <!--begin col-md-6 -->
                <div class="col-md-6">
                    <div class="main-services" [attr.data-aos]="isMobile ? 'fade-up' : 'fade-left'"
                        data-aos-duration="1000">
                        <i class="icon-bg-1 fas fa-money-bill-alt"></i>
                        <h4>Global Money Transfers</h4>
                        <p>We offer a wide global coverage with transfers to over 180 countries worldwide. Save on every
                            transfer with the best exchange rates and low fees.
                        </p>
                    </div>
                </div>
                <!--end col-md-6 -->
                <!--begin col-md-6 -->
                <div class="col-md-6">
                    <div class="main-services" [attr.data-aos]="isMobile ? 'fade-up' : 'fade-right'"
                        data-aos-duration="1000">
                        <i class="icon-bg-2 fas fa-wallet"></i>
                        <h4>SingX Wallet</h4>
                        <p>We have launched our very own SingX SGD Wallet - top up once, use multiple times! You no
                            longer
                            have to transfer funds to us for every transaction.
                        </p>
                    </div>
                </div>
                <!--end col-md-6 -->
            </div>
            <!--end row -->
        </div>
        <!--end container -->
    </div>
    <!--end services-wrapper -->
</section>
<!--end Services-We-offer -->

<app-how-it-works [isMobile]="isMobile"></app-how-it-works>

<app-why-singx [isMobile]="isMobile"></app-why-singx>

<app-country-coverage></app-country-coverage>

<!--begin Mobile-App -->
<section id="about" [attr.class]="isMobile ? 'section-bg-2 pb-2 pt0' : 'section-bg-2 pb-2 '">
    <!--begin services-wrapper -->
    <div class="services-wrapper">
        <div class="container">
            <div class="app-download-inner">
                <div class="row align-items-center">
                    <div class="col-lg-7 col-md-12">
                        <div class="app-download-content">
                            <h3 _ngcontent-serverapp-c67="" class="text-white mt-2" style="padding-bottom: 0.5em;">
                                Download the SingX Mobile App</h3>
                            <ul class="text-white">
                                <li><i class="fas fa-dot-circle text-orange" style="font-size: 0.8em;"></i>Check Live
                                    Exchange Rates</li>
                                <li><i class="fas fa-dot-circle text-orange" style="font-size: 0.8em;"></i>Transfer
                                    Overseas anytime, anywhere</li>
                                <li><i class="fas fa-dot-circle text-orange" style="font-size: 0.8em;"></i>Track your
                                    Transfers</li>
                            </ul>
                            <div class="btn-box d-flex aap-ios">
                                <a href="https://play.google.com/store/apps/details?id=com.maxstacklabs.app.singx"
                                    class="playstore-btn" [attr.data-aos]="'fade-up'" target="_blank" rel="noreferrer">
                                    <img id="img1" class="lazyload" data-src="./assets/images/play_store.webp"
                                        width="150px" alt="Download SingX App on Google Play Store">
                                    <img id="img2" class="lazyload" data-src="./assets/images/play_store.webp"
                                        width="130px" alt="Download SingX App on Google Play Store">
                                </a><span style="padding: 10px;"></span>
                                <a 
                                    href="https://apps.apple.com/us/app/singx/id1348313475" class="applestore-btn"
                                    target="_blank" [attr.data-aos]=" 'fade-up'" rel="noreferrer">
                                    <img id="img1" class="lazyload" data-src="./assets/images/app_store.webp"
                                        width="150px" alt="Download SingX App on Apple Play Store">
                                    <img id="img2" class="lazyload" data-src="./assets/images/app_store.webp"
                                        width="130px" alt="Download SingX App on Apple Play Store">
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-5 col-md-12">
                        <div class="app-download-image" [attr.data-aos]="isMobile ? 'fade-up' : 'fade-up'">
                            <img data-src="assets/images/m_a.webp" class="lazyload"
                                alt="SingX - Money Transfer Overseas - Download App Now" width="100%" max-width="90vw">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--end services-wrapper -->
</section>
<!--end Mobile-App -->


<!--begin testimonials section -->
<section id="testimonials" [attr.class]="isMobile ? 'section-bg-2 pt0 ' : 'section-bg-2'">

    <!--begin container -->
    <div class="container">

        <!--begin row -->
        <div class="row align-items-center">
            <div class="col-md-12">
                <h3 class="text-center mb-5 happycust">Happy Customers Say it Best!</h3>
                <!-- Demo header-->
                <div id="tcar" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                        <li data-target="#tcar" data-slide-to="0" class="active"></li>
                        <li data-target="#tcar" data-slide-to="1"></li>
                        <li data-target="#tcar" data-slide-to="2"></li>
                        <li data-target="#tcar" data-slide-to="3"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="carousel-item" style="min-height: 500px;margin:10px;"
                            *ngFor="let t of testimonialItems;let indexOfelement=index;"
                            [class.active]="indexOfelement == 0">
                            <div class="row">
                                <div class="col-md-5 col-sm-12" *ngIf="t.name_l">
                                    <div
                                        [attr.class]="isMobile ? 'card bg-white shadow rounded p-5 cardHWMob ' : 'card bg-white shadow rounded p-5 cardHWDesk'">
                                        <h6>{{t.name_l}}</h6>
                                        <p style="font-size: 17px;"> <i
                                                class="fa fa-quote-left mr-3 text-orange"></i>{{t.content_l}}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-1"></div>
                                <div class="col-md-5 col-sm-12" *ngIf="t.name_r">
                                    <div
                                        [attr.class]="isMobile ? 'card bg-white shadow rounded p-5 cardHWMob ' : 'card bg-white shadow rounded p-5 cardHWDesk'">
                                        <h6>{{t.name_r}}</h6>
                                        <p style="font-size: 17px;"> <i
                                                class="fa fa-quote-left mr-3 text-orange"></i>{{t.content_r}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end col-md-6-->
        </div>
        <!--end row -->
    </div>
    <!--end container -->
</section>
<!--end testimonials section -->


<div class="ltn__call-to-action-area call-to-action-6">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="call-to-action-inner">
                    <div class="row">
                        <div class="col-md-12 col-sm-12 text-center">
                            <h4 class="center"
                                style="text-align: center;color: #071e55; font-weight: bold;font-size: 40px;">WELCOME
                                OFFER</h4>
                            <h3 class="center text-white text-bold">Enjoy your first 2 Transfers absolutely FREE!</h3>
                            <br>
                            <a (click)="redirectToRegistrationPage()" rel="noreferrer" class="btn btn-light bg-white font_inter"
                                style="padding: 1rem 2rem; border-radius: 10px;color: #ff6600!important;font-weight: bolder;">Sign
                                Up in 5 Mins!
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" style="padding: 20px;"></div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>